var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternal)?_c('a',{attrs:{"href":_vm.formatedUrl,"target":_vm.target},on:{"click":function($event){return _vm.toUrl()}}},[_vm._t("default")],2):_c('router-link',_vm._b({},'router-link',_vm.originProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }